export default __webpack_public_path__ + "static/realization-1-7140385c0b939df170cfdb33b39b90e2.jpg";